import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { Button, ButtonType } from "../../../Components/Button/Button";
import { Spinner } from "../../../Components/Spinner";
import { ButtonFrameworkVariant } from "../../../Components/ButtonFramework/ButtonFramework";
import { mapRowsByProp } from "../../MetaBuyingUtils";
import * as R from "ramda";
import { DROPDOWN_BTN, SEARCH_MENU } from "../../MetaBuyingConstants";

interface SingleSelectMenuProps {
  placeholder: string;
  menuId: string;
  data: Record<string, any>[];
  nameProp: string;
  closeMenu: () => void;
  showMenu: boolean;
  applySelection: (value: string | number) => void;
  removeSelection: () => void;
  appliedSelection: number;
  loading?: boolean;
}

export const SingleSelectMenu = ({
  placeholder,
  menuId,
  data,
  nameProp = "name",
  closeMenu,
  showMenu,
  applySelection,
  removeSelection,
  appliedSelection,
  loading = false,
}: SingleSelectMenuProps): JSX.Element => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedId, setSelectedId] = useState<number>(-1);

  const dropdownBtnId = [menuId, DROPDOWN_BTN].join("_");
  const searchMenuId = [menuId, SEARCH_MENU].join("_");

  const idMap = mapRowsByProp("id", data);

  return (
    <div id={dropdownBtnId} className="metaBuyingSearchMenu menuToggle">
      <Button className="dropdown-toggle" type={ButtonType.OUTLINED}>
        {appliedSelection && idMap[appliedSelection] && idMap[appliedSelection][nameProp] ? (
          <div
            className="appliedSelection"
            onClick={() => {
              removeSelection();
              setSelectedId(-1);
              closeMenu();
            }}
          >
            <span>{idMap[appliedSelection][nameProp]}</span>
          </div>
        ) : (
          <span className="searchMenuPlaceholder">{placeholder}</span>
        )}
      </Button>
      {showMenu && (
        <div id={searchMenuId} className="searchMenu menuToggle">
          {" "}
          <div>
            <Form.Control
              size="sm"
              className="searchBar"
              placeholder="Search"
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
            />
            <div className="searchMenuRows">
              {loading ? (
                <Spinner size={50} />
              ) : (
                data
                  .filter(({ name }) => new RegExp(searchQuery, "ig").test(name))
                  .map((option, index) => (
                    <div key={index} className="searchMenuRow">
                      <Form.Check
                        className="searchMenuOption"
                        key={index}
                        type="radio"
                        label={option[nameProp]}
                        checked={selectedId === option.id}
                        id={option[nameProp]}
                        onChange={() => setSelectedId(option.id)}
                      />
                    </div>
                  ))
              )}
            </div>
            <div className="searchMenuControls">
              <Button
                type={ButtonType.OUTLINED}
                variant={ButtonFrameworkVariant.NO_ICON}
                onClick={closeMenu}
              >
                Cancel
              </Button>
              <Button
                disabled={loading || R.isEmpty(selectedId)}
                type={ButtonType.FILLED}
                variant={ButtonFrameworkVariant.NO_ICON}
                onClick={() => {
                  applySelection(selectedId);
                  closeMenu();
                }}
              >
                Apply
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
